import type { TestGroupingElementValue } from '@vedalib/editor/lib/elements'
import { CONFIG_ELEMENTS } from '@vedalib/editor/lib/elements'
import { FileUsageSource } from '@vedalib/editor/lib/files'
import { generateId } from '@vedalib/editor/lib/utils/id'
import { textToRtValue } from '@vedalib/rich-text'

import { DEMO_MODE } from 'services/Store/Project/constants'
import { t } from 'services/Translation'

import DemoWrapper from '../../decorators/DemoWrapper'
import Element from './TestGroupingElement'
import type { TestGroupingDemoType } from './testGroupingTypes'

const imageValue = {
  source: FileUsageSource.file,
  id: '',
  accessibility: '',
}

const DEMO_VALUE: TestGroupingElementValue = {
  items: [
    {
      value: generateId(),
      target: {
        label: textToRtValue(t('elements.grouping.value.firstLabel')),
        image: imageValue,
        overlay: null,
      },
      items: [
        {
          value: generateId(),
          label: textToRtValue(
            t('elements.grouping.value.firstItem', {
              elem: t('elements.grouping.value.firstElem'),
            }),
          ),
          image: imageValue,
          overlay: null,
        },
        {
          value: generateId(),
          label: textToRtValue(
            t('elements.grouping.value.firstItem', {
              elem: t('elements.grouping.value.secondElem'),
            }),
          ),
          image: imageValue,
          overlay: null,
        },
        {
          value: generateId(),
          label: textToRtValue(
            t('elements.grouping.value.firstItem', {
              elem: t('elements.grouping.value.thirdElem'),
            }),
          ),
          image: imageValue,
          overlay: null,
        },
      ],
    },
    {
      value: generateId(),
      target: {
        label: textToRtValue(t('elements.grouping.value.secondLabel')),
        image: imageValue,
        overlay: null,
      },
      items: [
        {
          value: generateId(),
          label: textToRtValue(
            t('elements.grouping.value.secondItem', {
              elem: t('elements.grouping.value.firstElem'),
            }),
          ),
          image: imageValue,
          overlay: null,
        },
        {
          value: generateId(),
          label: textToRtValue(
            t('elements.grouping.value.secondItem', {
              elem: t('elements.grouping.value.secondElem'),
            }),
          ),
          image: imageValue,
          overlay: null,
        },
        {
          value: generateId(),
          label: textToRtValue(
            t('elements.grouping.value.secondItem', {
              elem: t('elements.grouping.value.thirdElem'),
            }),
          ),
          image: imageValue,
          overlay: null,
        },
      ],
    },
  ],
  showResult: true,
}

const TestGroupingDemo: TestGroupingDemoType = ({ styles, fonts, feedback }) => (
  <DemoWrapper>
    <Element
      element={{
        id: `${CONFIG_ELEMENTS.testGrouping.type}-demo`,
        type: CONFIG_ELEMENTS.testGrouping.type,
        value: DEMO_VALUE,
        style: {},
        font: {},
        feedback: {},
      }}
      feedback={feedback}
      font={fonts}
      mode={DEMO_MODE}
      styles={styles}
    />
  </DemoWrapper>
)

export default TestGroupingDemo
